<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch1">
<div class="chapterHead">
<p class="centerImage0"><img alt="image" src="images/ch1.jpg" width="4%"/></p>
</div>
<p class="para" style="text-indent: 5%;"><a id="pg-1">What a crummy vacation!</a></p><a id="pg-1">
<p class="para" style="text-indent: 5%;">You, your little brother Denny, and your parents have come to New York City for Christmas vacation. You thought you’d get to do a lot of cool things, like visit the Statue of Liberty, ride to the top of the Empire State Building, and ice-skate at Rockefeller Center.</p>
<p class="para" style="text-indent: 5%;">Instead, your parents are museum freaks.</p>
<p class="para" style="text-indent: 5%;">“It’s entertaining,” your mom says as she drags you into the Museum of Natural History.</p>
<p class="para" style="text-indent: 5%;">“It’s educational,” your dad declares as he shows you a collection of ancient pottery.</p>
<p class="para" style="text-indent: 5%;">“It’s boring!” you say, but no one listens.</p>
<p class="para" style="text-indent: 5%;">And the worst part is that you’re supposed to be in charge of your little red-haired brother Denny. Only Denny doesn’t want anyone to be in charge of him. “You’re not the boss of me!” he keeps saying.</p>
<p class="para" style="text-indent: 5%;">You follow your parents through the Museum of Natural History. At first it is kind of interesting. You really like the dinosaurs.</p>
<p class="para" style="text-indent: 5%;">“Wait till you see what’s in this room!” your mom cries.</p>
</a><p class="extractLetterText" style="text-indent: 5%;"><a id="pg-1"><em class="italic">Go to </em></a><a href="#/e9780545841016_ch002"><em class="italic">PAGE 2</em></a>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9780545841016_ch001.vue?a01aa93e